import styled from '@emotion/styled';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { focusRingStyle } from '../../utils/sharedStyles';

export const StyledListItem = styled.li`
  padding: var(--podium-cds-size-spacing-s) 0;
  a {
    width: fit-content;
    display: block;
    p {
      color: var(--podium-cds-color-text-primary);
      &:hover {
        color: var(--podium-cds-color-text-secondary);
      }
    }
  }
`;

export const StyledButton = styled(ButtonStyled)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 16px;
  gap: 4px;
  min-width: 92px;
  width: auto;
  height: 36px;
  background-color: var(--podium-cds-color-bg-secondary);
  color: var(--podium-cds-color-text-primary)
  border-radius: 24px;
  flex: none;
  order: 5;
  flex-grow: 0;
  margin: 8px 16px 8px 0;

  &&:hover {
    background-color: var(--podium-cds-color-bg-hover);
    border-color: var(--podium-cds-color-bg-hover);
  }

  ${focusRingStyle}
`;
